import { useMemo } from 'react';

import { createLocator } from '@app/common/configurable-wizards/multilocator';
import { FieldLocator } from '@app/common/configurable-wizards/types';

export const useUserSettingsLocator = (locators: FieldLocator[] = []) => {
  const locator = useMemo(() => createLocator('', '', [
    ...locators,
  ]), []);

  return locator;
};
